import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import {
  computeAverages,
  DEFAULT_DAYS,
  DEFAULT_MAIN_WEATHERS,
  DEFAULT_SUB_WEATHERS,
  DEFAULT_TIER,
  totalGameCountOf,
} from '../top_ranker/statMetrics';

// 캐릭터/무기 통계를 한 번 불러온다(기본: 14일, 다이아+, 전 날씨). 인식 결과를 지표로 바꿀 때 쓴다.
export default function useTopRankerStats({ days = DEFAULT_DAYS, tier = DEFAULT_TIER } = {}) {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    axios.get('/api/external/bser/top-ranker-stats', {
      params: {
        days,
        tier,
        mainWeathers: DEFAULT_MAIN_WEATHERS.join(','),
        subWeathers: DEFAULT_SUB_WEATHERS.join(','),
      },
    })
      .then((r) => { if (!cancelled) setStats(Object.values(r.data)); })
      .catch(() => { if (!cancelled) setError('통계를 불러오지 못했어요.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [days, tier]);

  const totalGameCount = useMemo(() => totalGameCountOf(stats), [stats]);
  const averages = useMemo(() => computeAverages(stats), [stats]);
  return { stats, totalGameCount, averages, loading, error };
}
